import {
  createReqConsts,
  createActions,
  createReqWatcher,
} from '../../../utils/redux';

export const consts = createReqConsts('health-board', 'cancel-invite-quest');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'appointments',
  type: 'delete',
  slug: ['virtual_visits', 'room_invitation'],
});



// WEBPACK FOOTER //
// ./src/redux/healthboard/requests/cancel-invitation-to-virtual-room-req.js